export * from './correct-score-adj-slider';